const ferries = {
  ferry: "नौका", // translated 
  ferries: "घाट", // translated 
  selectOriginPort: "उत्पत्ति पोर्ट का चयन करें", // translated 
  selectDestPort: "गंतव्य बंदरगाह का चयन करें", // translated 
  continue: "जारी रखना", // translated 
  viewTimetables: "समय सारिणी देखें", // translated 
  operator: "ऑपरेटर", // translated 
  cabin: "केबिन", // translated 
  cabins: "केबिनों", // translated 
  place: "जगह", // translated 
  places: "स्थानों", // translated 
  seat: "सीट", // translated 
  seats: "सीटें", // translated 
  seating: "बैठने की", // translated 
  deckSpace: "डेक स्पेस", // translated 
  compulsory: "अनिवार्य", // translated 
  departure: "प्रस्थान", // translated 
  total: "कुल", // translated 
  back: "पीछे", // translated 
  next: "अगला", // translated 
  duration: "अवधि", // translated 
  return: "वापस करना", // translated 
  prebook: "पहले से बुकिंग करें", // translated 
  travelInfo: "यात्रा जानकारी", // translated 
  book: "किताब", // translated 
  adults: "वयस्कों", // translated 
  child: "बच्चा", // translated 
  seniors: "वरिष्ठ", // translated 
  senior: "वरिष्ठ", // translated 
  to: "को", // translated 
  passenger: "यात्री", // translated 
  details: "विवरण", // translated 
  currencyForTickets: "इन टिकटों की मुद्रा होगी", // translated 
  seatsError: "यात्रियों की संख्या क्षमता के बराबर नहीं है।", // translated 
  title: "शीर्षक", // translated 
  firstName: "पहला नाम", // translated 
  lastName: "उपनाम", // translated 
  email: "ईमेल", // translated 
  phone: "फ़ोन", // translated 
  dateOfBirth: "जन्म तिथि", // translated 
  placeOfBirth: "जन्म स्थान", // translated 
  groupLeader: "समूह के नेता", // translated 
  isRequired: "आवश्यक है", // translated 
  charactersOnly: "केवल अक्षर", // translated 
  latinCharactersAndSpacesOnly: "केवल लैटिन अक्षर और रिक्त स्थान", // translated 
  validEmail: "यह मान्य ईमेल नहीं है", // translated 
  atLeastOneAdult: "कम से कम 1 वयस्क का होना अनिवार्य है।", // translated 
  atLeastOneSenior: "कम से कम 1 वरिष्ठ सदस्य की आवश्यकता है।", // translated 
  toastAlert: "कृपया नीचे दिए गए फॉर्म में सभी त्रुटियों को ठीक करें।", // translated 
  backToFerriesList: "फेरी सूची पर वापस जाएँ", // translated 
  bestPrice: "सबसे अच्छी कीमत", // translated 
  fastest: "सबसे तेजी से", // translated 
  beforeDeparture: "रवाना होने से पहले", // translated 
  perPerson: "प्रति व्यक्ति", // translated 
  notAvailableForOnlineBooking: "ऑनलाइन बुकिंग के लिए उपलब्ध नहीं है", // translated 
  hurryLimitedAvailability: "जल्दी करें! सीमित स्टॉक उपलब्ध है।", // translated 
  berth: "बर्थ", // translated 
  berths: "बर्थ", // translated 
  sumOfSelectionNotEqualToPersons:
    "आपके द्वारा चुने गए विकल्पों का योग यात्रियों की संख्या के बराबर नहीं है।", // translated 
  attemptToBook: "आपने कुल मिलाकर बुकिंग करने का प्रयास किया है", // translated 
  seatsWhenYouHave: "जब आपके पास सीटें हों", // translated 
  passengersTravelling: "यात्री यात्रा कर रहे हैं", // translated 
  withReturn: "वापसी टिकटों के साथ", // translated 
  pleaseCorrectYourSelection: "कृपया अपना चयन सही करें", // translated 
  pleaseSelectUpTo: "कृपया अधिकतम का चयन करें", // translated 
  accommodationTypes: "आवास के प्रकार", // translated 
  selectionPrices: "चयन मूल्य", // translated 
  yourCurrentTicket: "आपके वर्तमान टिकट का प्रकार है", // translated 
  upgradeTo: "में अपग्रेड", // translated 
  wouldYouLikeToUpgrade: "क्या आप अपने टिकट का प्रकार अपग्रेड करना चाहेंगे?", // translated 
  backToTicketTypes: "टिकट प्रकारों पर वापस जाएँ", // translated 
  originPort: "उत्पत्ति बंदरगाह", // translated 
  destinationPort: "गंतव्य बंदरगाह", // translated 
  outboundDate: "आउटबाउंड तिथि", // translated 
  inboundDate: "आवक तिथि", // translated 
  passengers: "यात्रियों", // translated 
  hasReturn: "वापसी हो गई है", // translated 
  passportNumber: "पासपोर्ट संख्या", // translated 
  passportExpiryDate: "पासपोर्ट समाप्ति की दिनांक", // translated 
  passportPlaceOfIssue: "पासपोर्ट जारी करने का स्थान", // translated 
  passportStartDate: "पासपोर्ट शुरू होने की तिथि", // translated 
  cityCode: "शहर का कोड", // translated 
};


export default ferries;
